export default [
  // 口罩列表
  {
    path: "/maskList",
    name: "MaskList",
    meta: {
      title: "商品列表",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/mask/MaskList.vue")
  },
  // 口罩详情页
  {
    path: "/maskGoodsCon/:id",
    name: "MaskGoodsCon",
    meta: {
      title: "商品详情页",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/mask/MaskGoodsCon.vue")
  },
  {
    path: "/mask/submit/:id",
    name: "MaskOrderSubmission",
    meta: {
      title: "提交订单",
      keepAlive: true,
      auth: true
    },
    component: () => import("@views/moblie/mask/MaskOrderSubmission")
  }
];
